import { Button } from "../ui";

export function CloseButton({
  onClick,
  variant = "secondary",
  className,
}: {
  onClick: () => void;
  variant?: "primary" | "secondary";
  className?: string;
}) {
  return (
    <Button
      buttonType={variant === "primary" ? "closePrimary" : "closeSecondary"}
      onClick={onClick}
      className={className ?? "font-medium"}
      data-testid="modal-close"
    >
      Close
    </Button>
  );
}
